import ReactionFilter from '@/AdminComponent/Reactions/components/Filter';
import ReactionTable from '@/AdminComponent/Reactions/components/ReactionsTable';
import { useReactions } from '@/AdminComponent/Reactions/hooks/useReactions';
import React from 'react';
import '@/AdminComponent/admin.css';
import RestoreIcon from '@mui/icons-material/Restore';
import Button from 'react-bootstrap/Button';
import { OutlinedInput } from '@mui/material';
import { buildRoutes } from '@/service/buildRoutes';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { reactionTableLimitAtom } from '@/data/atoms/reactionAtom';
import ReactionSort from '@/AdminComponent/Reactions/components/Sort';

const ReactionsV2 = () => {
	const navigate = useNavigate();
	const existingLimit = useAtomValue(reactionTableLimitAtom);
	const {
		searchQuery,
		availableInstructors,
		selectedInstructors,
		availableCategories,
		selectedCategories,
		sortBy,
		isLoading,
		filteredData,
		pagination,
		handleSearchQuery,
		handleSortChange,
		handleReset,
		isResetDisabled,
		handleSelectedInstructors,
		handleSelectedCategories,
		handlePageChange,
		handleLimitChange
	} = useReactions({ existingLimit });

	return (
		<div className="white-container">
			<div className="mb-3 d-flex justify-content-between">
				<h2>Reactions</h2>
				<Button
					variant="primary"
					onClick={() => {
						navigate(buildRoutes.toReactionStats());
					}}
				>
					View Stats
				</Button>
			</div>
			<div className="search-instructor-section">
				<OutlinedInput
					type="text"
					placeholder="Search by title"
					className="reactions-search-input"
					value={searchQuery}
					onChange={e => handleSearchQuery(e.target.value)}
				/>

				<div className="reactions-filter-section">
					<ReactionFilter
						originalTargets={availableInstructors}
						selectedTargets={selectedInstructors}
						setSelectedTargets={handleSelectedInstructors}
						title="Instructors"
					/>

					<ReactionFilter
						originalTargets={availableCategories}
						selectedTargets={selectedCategories}
						setSelectedTargets={handleSelectedCategories}
						title="Categories"
					/>

					<ReactionSort sortBy={sortBy} handleSort={handleSortChange} />

					<Button variant="outline-danger" onClick={handleReset} disabled={isResetDisabled}>
						<RestoreIcon />
					</Button>
				</div>
			</div>

			<div className="mt-4">
				{isLoading ? (
					<p>Loading reactions...</p>
				) : filteredData.length > 0 ? (
					<ReactionTable
						data={filteredData}
						pagination={pagination}
						handlePageChange={handlePageChange}
						handleLimitChange={handleLimitChange}
						sortBy={sortBy}
						handleSort={handleSortChange}
					/>
				) : (
					<p>No reactions found.</p>
				)}
			</div>
		</div>
	);
};

export default ReactionsV2;
